import { APP_VERSION } from '@just-us/shared'
/**
 * hooks/use-app-version.ts
 *
 * Calls GET /version on the API to detect when the deployed API version
 * differs from the frontend's APP_VERSION. A mismatch means the PWA is
 * running stale cached JS against a newer API — show the update banner
 * so the user refreshes to load the latest bundle.
 */
import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../lib/api-client'

const compareVersions = (a: string, b: string): number => {
  const partsA = a.split('.').map(Number)
  const partsB = b.split('.').map(Number)
  for (let i = 0; i < 3; i++) {
    const partA = partsA[i] ?? 0
    const partB = partsB[i] ?? 0
    if (partA !== partB) return partA - partB
  }
  return 0
}

export const useAppVersion = () => {
  const { data, error } = useQuery({
    queryKey: ['app-version'],
    queryFn: async () => {
      const res = await apiFetch<{ version: string }>('/version')
      return res as { version: string }
    },
    staleTime: 0,
    gcTime: 0,
    retry: 1,
  })

  const apiVersion = data?.version
  const needsUpdate =
    !error && apiVersion !== undefined && compareVersions(APP_VERSION, apiVersion) < 0

  return { needsUpdate }
}
